export type TIconSetName =
  | "lightbulb-multiple"
  | "lightbulb"
  | "power-plug"
  | "water-pump"
  | "window-shutter"
  | "lightbulb-group"
  | "track-light";

interface IIconSet {
  on: string;
  off: string;
}

export const IconSets: { [key in TIconSetName]: IIconSet } = {
  "lightbulb-multiple": {
    on: "lightbulb-multiple-outline",
    off: "lightbulb-multiple-off-outline",
  },
  lightbulb: { on: "lightbulb-outline", off: "lightbulb-off-outline" },
  "power-plug": {
    on: "power-plug-outline",
    off: "power-plug-off-outline",
  },
  "water-pump": { on: "water-pump", off: "water-pump-off" },
  "window-shutter": { on: "window-shutter-open", off: "window-shutter" },
  "lightbulb-group": {
    on: "lightbulb-group-outline",
    off: "lightbulb-group-off-outline",
  },
  "track-light": { on: "track-light", off: "track-light-off" },
};
